<template>
  <div class="flex max-h-[500px] p-5">
    <div class="w-[280px] desktop:w-[340px]">
      <ul
        class="container-scrollbar h-full w-full overflow-y-auto overflow-x-hidden overscroll-y-contain pr-1"
      >
        <slot name="left" />
      </ul>
    </div>
    <div class="w-[calc(100%-280px)] pl-5 desktop:w-[calc(100%-340px)]">
      <slot name="right" />
    </div>
  </div>
</template>
